import './App.css';

import { useState, useEffect } from 'react';

import { HashRouter, Routes, Route } from 'react-router-dom'

//import Tillfällig from './pages/Tillfällig';

import Index from './pages/Index';
import Information from './pages/Information';
import Schema from './pages/Schema';
//import Event from './pages/Event';
import N0llehandboken from './pages/N0llehandboken';

import {Header, Footer} from './components/Layout';
import Hero from './components/Hero';

function App() {

    return (
      <HashRouter>
      
        <Header />

        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/information" element={<Information />} />
          <Route path="/schema" element={<Schema />} />
          {/*<Route path="/event" element={<Event />} />*/}
          <Route path="/n0llehandboken" element={<N0llehandboken />} />
        </Routes>

        <Footer />
      
      </HashRouter>
    );
}
export default App;